export default __webpack_public_path__ + "static/media/moniepointLogo.80cabb0c.svg";